module.exports = __webpack_public_path__ + "static/media/coin_pl.1a52a45c.png";